// extracted by mini-css-extract-plugin
export default {"tooltip":"WithTooltip_tooltip__D94f9","arrow":"WithTooltip_arrow__m7MQI"};